import { Typography, styled } from "@mui/material";

export const ConsentContainer = styled("div")(({ theme }) => ({
  position: "fixed",
  bottom: "10px",
  left: "10px",
  right: "10px",
  borderRadius: "20px",
  boxShadow: `0.2rem 0.2rem 1rem ${theme.palette.color.content.shadow}`,
  backgroundColor: theme.palette.color.blue.dark,
  color: "white",
  fontSize: "0.9rem",
  lineHeight: "0.9rem",
  textAlign: "center",
  zIndex: 9999999,
  overflow: "hidden",

  "& strong": {
    marginRight: "8px",
    fontSize: "1rem",
  },
}));

export const ConsentContent = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",

  "& div": {
    width: "80%",
    padding: "1rem",
    lineHeight: "1.35rem",
  },
});

export const ConsentWrapper = styled("div")({
  textAlign: "left",
});

export const ConsentHeader = styled(Typography)({
  color: "white",
  fontWeight: "bold",
  fontSize: "1.25rem",
  margin: 0,
  padding: 0,
});

export const ConsentButton = styled("a")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.1rem",
  fontWeight: "bold",
  background: theme.palette.color.blue.medium,
  color: "white !important",
  padding: "0.25rem",
  width: "20%",

  "&:hover": {
    background: theme.palette.color.main.primary,
    transition: "0.25s ease",
  },
}));
